<template lang="pug">
v-app(style='background: #FFFFFF !important;')
  v-container(fluid, grid-list-xl)
    v-content
      v-layout(row, justify-center)
        v-flex(xs12, sm12, md10, lg9, text-xs-center)
          v-card(flat)
            breadcrumb(back='page2-1')
            v-card-text.label16tt.withDivider(style='margin-top:-58px;')
              | LECCIÓN: ELIGE TU CRÉDITO HIPOTECARIO
            v-card-text.titulo36Book
              | ¡Quiero saber cómo me protege un Crédito Hipotecario!
            p
              img(style='width:100%;', src='assets/TCH-L2.3-portada.jpg')
            v-card-text.parrafoDestacado18
              | La decisión de adquirir un Crédito Hipotecario conlleva momentos de reflexión y duda. 
              | El siguiente escenario te invita a plasmar tu percepción sobre este instrumento financiero desde una perspectiva futura.
            v-btn.btn(justify-space-between, type='button', color='primary', @click.prevent="nextPage('page3-2')")
              | Siguiente
          l-progress(:value='this.$parent.currentPage')

</template>

<script>
import {
  eventBus
} from '../main';
export default {
  name: 'app',
  data() {
    return {
      progress: false
    }
  },
  methods: {
    nextPage(page) {
      this.progress = true;
      eventBus.$emit('next_page', page);
    }
  }
};
</script>
